import '../plugins/MediaelementPlayerPlugin.js';


//init mediaelement player
export default function initMediaelementPlayer(opt) {
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

	jQuery('video:not(.bg-video)').each(function() {
		var player = new MediaElement(this, {
			pluginPath: window.pathInfo ? pathInfo.base + 'mediaelement/' : 'mediaelement/',
			setDimensions: false,
			enableAutosize: false,
			//alwaysShowControls: true,
			iPadUseNativeControls: true,
			AndroidUseNativeControls: true,
			useSmoothHover: false,
			useDefaultControls: false,
			youtube: {
				iv_load_policy: 3,
				modestbranding: 1,
				rel: 0,
				showinfo: 1
			},
			success: function(mediaelement, video, inst) {
				var $video = jQuery(video);
				var $holder = $video.closest('.mejs-player');
				var $playTriggers = $holder.find('.mejs__overlay');

				$video.data('playerApi', mediaelement);

				// class for touch device
				if (isTouchDevice) {
					$holder.addClass('is-touch-device');
				}

				function playHandler(e) {
					e && e.preventDefault();

					const cookiesRequired = !!$video.data('cookiesRequired');
					const cookiesAccepted = !!(window.ccc && window.ccc.functional);
					const canLoadVideo = !cookiesRequired || (cookiesRequired && cookiesAccepted);
					if (!canLoadVideo) {
						$playTriggers.show().one('click', playHandler);
						return;
					}

					$playTriggers.hide();
					mediaelement.play();
					$holder.addClass('loading');
				}

				mediaelement.addEventListener('pause', function() {
					$video.trigger('playerApiPause');
				});

				mediaelement.addEventListener('play', function() {
					$video.trigger('playerApiPlay');
					$holder.addClass('ready').removeClass('loading').removeClass('ended');
				});

				$playTriggers.one('click', function() {
					playHandler();
				});

				mediaelement.addEventListener('ended', function() {
					if (!video.loop) {
						$holder.addClass('ended');

						$playTriggers.show().one('click', playHandler);
					}
					$video.trigger('playerApiEnded');
				});

				mediaelement.addEventListener('timeupdate', function() {
					$video.trigger('playerApiTimeupdate');
				});
			}
		});
	});
}
